import { render, staticRenderFns } from "./MealFoodPrepAssignment.vue?vue&type=template&id=a07a89b8&"
import script from "./MealFoodPrepAssignment.vue?vue&type=script&lang=js&"
export * from "./MealFoodPrepAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports